import { useSupabaseAuth } from '@/lib/supabase'
import ChatPanel from './ChatPanel'
import LoginPage from './LoginPage'
import OnboardingGate from './OnboardingCarousel'

export default function App() {
  const { isAuthenticated, loading } = useSupabaseAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-600">Authenticating...</p>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <LoginPage />
  }

  return (
    <div className="flex flex-col h-screen">
      <OnboardingGate>
        <ChatPanel />
      </OnboardingGate>
    </div>
  )
}
